// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_93-3";
export var contentContainer = "_93-0";
export var editorContainer = "_93-1";
export var quillInputForm = "_93-2";
export var zoneDivider = "_93-4";